<template>
  <div class="content">
    <div ref="pageTopAnchor" style="height:80px;margin-top:-80px;"></div>
    <div class="ceiling">
      <home-top></home-top>
      <navicat :current="7" background="#FFFFFF"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="content-body w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/project-transaction' }"
          >来料加工
          </el-breadcrumb-item
          >
          <el-breadcrumb-item>{{
              type == `natural` ? `工厂资源` : `加工需求`
            }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-box">
        <!-- 精美搜索组件 -->
        <div class="search-container">
          <div class="search-wrapper">
            <div class="search-input-group">
              <div class="search-icon">
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                  />
                </svg>
              </div>
              <input
                  v-model="search"
                  type="text"
                  class="search-input"
                  placeholder="请输入搜索内容"
                  @keyup.enter="handleSearch"
                  @focus="handleFocus"
                  @blur="handleBlur"
                  @input="handleInput"
              />
              <div class="search-actions">
                <button
                    v-if="search"
                    class="clear-btn"
                    @click="clearSearch"
                    title="清空搜索"
                >
                  <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M18 6L6 18M6 6L18 18"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button
                    class="search-btn"
                    @click="handleSearch"
                    :class="{ active: isFocused || search }"
                >
                  <span class="search-text">搜索</span>
                  <svg
                      class="search-arrow"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M5 12H19M19 12L12 5M19 12L12 19"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- 热门搜索标签 -->
          <!-- <div class="hot-search">
            <span class="hot-label">热门搜索：</span>
            <div class="hot-tags">
              <span
                v-for="(tag, index) in hotTags"
                :key="index"
                class="hot-tag"
                @click="searchByTag(tag)"
              >
                {{ tag }}
              </span>
            </div>
          </div> -->
        </div>
        <div class="body">

          <div>
            <template v-if="type == `natural`">
              <div class="content-list" v-if="loadingList">
                <el-skeleton style="width: 310px;height: 224px" animated v-for="i  in 8" :key="i">
                  <template slot="template">
                    <div style="display: flex; align-items: center; justify-content: space-between; ">
                      <el-skeleton-item variant="p" style="width: 15%;height: 24px"/>
                      <el-skeleton-item variant="p" style="width: 70%;height: 24px"/>
                    </div>
                    <div style="padding: 14px 0;">
                      <el-skeleton-item variant="p"/>
                      <el-skeleton-item variant="p"/>
                      <el-skeleton-item variant="p"/>
                      <el-skeleton-item variant="p"/>
                      <div
                          style="display: flex; align-items: center; justify-content: space-between; padding: 5px 0;"
                      >
                        <el-skeleton-item variant="text" style="margin-right: 16px;height: 20px"/>
                        <el-skeleton-item variant="text" style="width: 30%;height: 20px"/>
                      </div>

                    </div>
                    <div
                        style="display: flex; align-items: center; justify-content: space-between;"
                    >
                      <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                      <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                      <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                      <el-skeleton-item variant="text" style="width: 20%;height: 20px"/>
                    </div>
                  </template>
                </el-skeleton>
              </div>
              <div class="content-list">
                <div
                    class="content-list-item"
                    v-for="(item, index) in informationList"
                    :key="index"
                >
                  <information :data="item"></information>
                </div>
              </div>
            </template>
            <template v-if="type == `need`">
              <div class="content-list" v-if="loadingList">
                <el-skeleton style="width: 310px;height: 224px" animated v-for="i  in 8" :key="i">
                  <template slot="template">
                    <div style="display: flex; align-items: center; justify-content: space-between; ">
                      <el-skeleton-item variant="p" style="width: 15%;height: 24px"/>
                      <el-skeleton-item variant="p" style="width: 70%;height: 24px"/>
                    </div>
                    <div style="padding: 14px 0;">
                      <el-skeleton-item variant="p"/>
                      <el-skeleton-item variant="p"/>
                      <el-skeleton-item variant="p"/>
                      <el-skeleton-item variant="p"/>
                      <div
                          style="display: flex; align-items: center; justify-content: space-between; padding: 5px 0;"
                      >
                        <el-skeleton-item variant="text" style="width: 40%;height: 20px"/>
                      </div>

                    </div>
                    <div
                        style="display: flex; align-items: center; justify-content: space-between;padding: 5px 0;"
                    >
                      <el-skeleton-item variant="text" style="width: 40%;height: 20px"/>
                      <el-skeleton-item variant="text" style="width: 40%;height: 20px"/>
                    </div>
                  </template>
                </el-skeleton>
              </div>
              <div class="content-list">
                <div
                    class="content-list-item"
                    v-for="(item, index) in informationList"
                    :key="index"
                >
                  <need :data="item"></need>
                </div>
              </div>
            </template>
          </div>
          <empty v-if="informationList.length === 0&&!loadingList"></empty>
          <div class="pagination-box" v-else>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[20, 40, 60, 100]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import {proces_list} from "@/api/modules/home";
import navicat from "@/components/navicat/navicat";
import information from "@/components/goods/information";
import empty from "@/components/public/empty";
import need from "@/components/goods/need";
import HomeFooter from "../../../components/public/home-footer.vue";
import HomeTop from "../../../components/public/home-top.vue";

export default {
  name: "more",
  components: {
    HomeTop,
    HomeFooter,
    navicat,
    information,
    empty,
    need,
  },
  data() {
    return {
      type: this.$route.query.type,
      search: "",
      isFocused: false,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      informationList: [],
      loadingList: false,
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    search(newVal) {
      if (this.isFocused) {
      }
    },
  },
  methods: {
    getList() {
      let classification = this.type == `natural` ? 1 : 2;
      this.loadingList = true;
      proces_list(classification, {
        page: this.pageNum,
        limit: this.pageSize,
        keywords: this.search,
      }).then((res) => {
        this.informationList = res.data.data.data;
        this.total = res.data.data.total;
        this.loadingList = false;
      });
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getList();
    },
    handleCurrentChange(page) {
      this.pageNum = page;
      this.$refs.pageTopAnchor?.scrollIntoView({behavior: 'auto', block: 'start'})
      this.getList();
    },
    handleInput(e) {
      if (!e.target.value.trim()) {
        this.pageNum = 1;
        this.getList();
      }
    },

    // 处理搜索
    handleSearch() {
      if (!this.search.trim()) {
        this.$message.warning({
          message: "请输入搜索内容",
          duration: 2000,
          offset: 300,
        });
      } else {
        this.pageNum = 1;
        this.getList();
      }
    },

    // 清空搜索
    clearSearch() {
      this.search = "";
      this.pageNum = 1;
      this.getList();
      this.showSuggestions = false;
      this.$nextTick(() => {
        this.$refs.searchInput?.focus();
      });
    },

    // 处理输入框聚焦
    handleFocus() {
      this.isFocused = true;
      this.showSuggestions = true;
    },

    // 处理输入框失焦
    handleBlur() {
      this.isFocused = false;
      // 延迟隐藏建议，让用户有时间点击
    },
  },
};
</script>
<style scoped lang="scss">
.content-body {
  margin-bottom: 40px;

}

.h-top {
  height: 120px;
}

.bread-crumb {
  padding: 20px 0;
}

.body {
  padding: 30px;
  background: #ffffff;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .pagination-box {
    text-align: center;
    margin-top: 20px;
  }
}

.content-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  .content-list-item {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
}

// 精美搜索样式
.search-container {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
}

.search-wrapper {
  position: relative;
  margin-bottom: 20px;
}

.search-input-group {
  position: relative;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 2px solid #e1e5e9;
  border-radius: 50px;
  padding: 8px 8px 8px 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  &:hover {
    border-color: #409eff;
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.15);
  }

  &:focus-within {
    border-color: #409eff;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1),
    0 4px 16px rgba(64, 158, 255, 0.15);
    transform: translateY(-1px);
  }
}

.search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #909399;
  margin-right: 12px;
  transition: color 0.3s ease;

  .search-input-group:focus-within & {
    color: #409eff;
  }
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  color: #303133;
  padding: 12px 0;

  &::placeholder {
    color: #c0c4cc;
    transition: color 0.3s ease;
  }

  &:focus::placeholder {
    color: #909399;
  }
}

.search-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.clear-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  background: #f5f7fa;
  border-radius: 50%;
  color: #909399;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #e4e7ed;
    color: #606266;
    transform: scale(1.1);
  }
}

.search-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  background: linear-gradient(135deg, #409eff 0%, #71cbff 100%);
  color: white;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &.active {
    background: linear-gradient(135deg, #82dcff 0%, #61b5ce 100%);
    box-shadow: 0 2px 8px rgba(58, 144, 194, 0.3);

    &:hover {
      box-shadow: 0 4px 16px rgba(58, 156, 194, 0.4);
    }
  }
}

.search-text {
  transition: transform 0.3s ease;
}

.search-arrow {
  transition: transform 0.3s ease;

  .search-btn:hover & {
    transform: translateX(2px);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.suggestion-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f5f7fa;
  }

  &:first-child {
    border-radius: 12px 12px 0 0;
  }

  &:last-child {
    border-radius: 0 0 12px 12px;
  }
}

.suggestion-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #909399;
  margin-right: 12px;
}

.suggestion-text {
  color: #303133;
  font-size: 14px;
}

// 热门搜索样式
.hot-search {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  padding: 16px 0;
}

.hot-label {
  color: #909399;
  font-size: 14px;
  white-space: nowrap;
}

.hot-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.hot-tag {
  padding: 6px 12px;
  background: #f0f2f5;
  color: #606266;
  border-radius: 16px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;

  &:hover {
    background: #e1f3ff;
    color: #409eff;
    border-color: #b3d8ff;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .search-container {
    margin: 20px auto;
    padding: 0 16px;
  }

  .search-input-group {
    padding: 6px 6px 6px 16px;
  }

  .search-input {
    font-size: 14px;
    padding: 10px 0;
  }

  .search-btn {
    padding: 10px 20px;
    font-size: 13px;
  }

  .hot-search {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .hot-tags {
    width: 100%;
  }
}

// 深色模式支持
@media (prefers-color-scheme: dark) {
  .search-input-group {
    background: #2b2b2b;
    border-color: #404040;

    &:hover {
      border-color: #409eff;
    }
  }

  .search-input {
    color: #e5e5e5;

    &::placeholder {
      color: #666;
    }
  }

  .search-suggestions {
    background: #2b2b2b;
    border-color: #404040;
  }

  .suggestion-item:hover {
    background: #404040;
  }

  .suggestion-text {
    color: #e5e5e5;
  }

  .hot-tag {
    background: #404040;
    color: #e5e5e5;

    &:hover {
      background: #1a3a5f;
      color: #409eff;
    }
  }
}
</style>
